import React from 'react';
import styled from '@emotion/styled';
import { isEmpty, omit } from 'lodash';
import { NavLink, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LinkRedoute = function LinkRedoute(props) {
  var LinkComponent = props.disabled ? 'span' : !isEmpty(props.to) ? props.nav ? NavLink : Link : !isEmpty(props.href) ? 'a' : 'span';
  var LinkStyled = styled(LinkComponent)(function (_ref) {
    var theme = _ref.theme,
        disabled = _ref.disabled,
        hover = _ref.hover,
        visited = _ref.visited,
        active = _ref.active,
        focus = _ref.focus;
    var themeLink = !isEmpty(theme) && theme.link || {};
    return _objectSpread({}, themeLink, {}, disabled && themeLink[':disabled'] || {}, {}, hover && themeLink[':hover'] || {}, {}, visited && themeLink[':visited'] || {}, {}, active && themeLink[':active'] || {}, {}, focus && themeLink[':focus'] || {});
  });
  var filteredProps = props.disabled ? omit(props, ['nav', 'onClick', 'href', 'to']) : omit(props, ['nav']);
  return React.createElement(LinkStyled, filteredProps);
};

LinkRedoute.propTypes = {
  /** Internal url. When used, the component returned is a Link from react-router-dom */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** If the link is a Internal url, the nav props will load a NavLink instead of a Link */
  nav: PropTypes.bool,

  /** External url. When used, the component returned is a <a href> */
  href: PropTypes.string,

  /** To disable actions (href, to or onClick) on the link. Changes the visual state. */
  disabled: PropTypes.bool,

  /** Force hover state */
  hover: PropTypes.bool,

  /** Force visited state */
  visited: PropTypes.bool,

  /** Force active state */
  active: PropTypes.bool,

  /** Force focus state */
  focus: PropTypes.bool
};

export default LinkRedoute;
